import { Body2 } from 'stories/elements/Typography/Text'
import Breadcrumbs from 'components/modules/SEO/Breadcrumbs'
import styled from 'styled-components'
import { KnowSeoInfo } from 'interfaces/KnowSeoInfo'
import { generateBreadcrumbs } from 'lib/features/breadcrumbs'
import { useTranslation } from 'react-i18next'

const Container = styled.div`
    max-width: 1024px;
`

const EmptyBreadcrumbsContainer = styled(Body2)`
    padding-bottom: 10px;

    @media (max-width: 750px) {
        padding: 5px 0 0 5px;
    }
`

interface Props {
    knowSeoInfo: KnowSeoInfo | null
    referrerScreen?: string
}

const KnowBreadcrumbs = ({ knowSeoInfo, referrerScreen }: Props) => {
    const { t } = useTranslation()

    if (!knowSeoInfo) return null

    const parts = generateBreadcrumbs({
        knowSeoInfo,
        showKnowledgeAreaBreadcrumbs: true,
        t,
    })

    const showBreadcrumbs = !!knowSeoInfo && parts.length > 0

    return (
        <Container>
            {showBreadcrumbs ? (
                <Breadcrumbs breadcrumbs={parts} know={knowSeoInfo.know} referrerScreen={referrerScreen} />
            ) : (
                <EmptyBreadcrumbsContainer />
            )}
        </Container>
    )
}

export default KnowBreadcrumbs
